import { z } from 'zod';

export const rawIssueActionCountSchema = z.object({
  action_count: z.number(),
});
export type RawIssueActionCountSchema = z.infer<
  typeof rawIssueActionCountSchema
>;

export const issueActionCountSchema = rawIssueActionCountSchema.transform(
  (data) => ({
    actionCount: data.action_count,
  }),
);

export type IssueActionCountEntity = z.infer<typeof issueActionCountSchema>;
